const GOOGLE_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const GOOGLE_CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const GOOGLE_CALLBACK_URI = `${window.location.origin}/auth/callback`;

const getCookie = async (name) => {
 const cookieName = `${name}=`;
 const decodedCookie = decodeURIComponent(document.cookie);
 const cookieArray = decodedCookie.split(';');

 for (let i = 0; i < cookieArray.length; i++) {
 let cookie = cookieArray[i];
 while (cookie.charAt(0) === ' ') {
 cookie = cookie.substring(1);
 }
 if (cookie.indexOf(cookieName) === 0) {
 return cookie.substring(cookieName.length, cookie.length);
 }
 }
 return null;
};

const signInWithGoogle = async () => {
 try {
 // Redirect the user to the Google OAuth consent screen.
 window.location.href =
 `https://accounts.google.com/o/oauth2/v2/auth?` +
 `scope=email%20profile&` +
 `response_type=code&` +
 `client_id=${GOOGLE_CLIENT_ID}&` +
 `redirect_uri=${encodeURIComponent(GOOGLE_CALLBACK_URI)}`; // Replace with your redirect URI.
 } catch (error) {
 throw new Error(error);
 }
};

const handleOAuthCallback = async (code) => {
 try {
 
 const response = await fetch('https://oauth2.googleapis.com/token', {
 method: 'POST',
 headers: {
 'Content-Type': 'application/x-www-form-urlencoded',
 },
 body: new URLSearchParams({
 code,
 client_id: GOOGLE_CLIENT_ID,
 client_secret: GOOGLE_CLIENT_SECRET,
 redirect_uri: GOOGLE_CALLBACK_URI,
 grant_type: 'authorization_code',
 }),
 });
 console.log("code:",code)
 const data = await response.json();

 if (response.ok) {
 const accessToken = data.access_token;
 const expirationDate = new Date();
 expirationDate.setTime(expirationDate.getTime() + 60 * 60 * 1000 * 24 * 10); // 10 days in milliseconds
 document.cookie = `token=${accessToken}; expires=${expirationDate.toUTCString()}; path=/`;
 window.location.href = '/dashboard';
 } else {
 console.error('Token exchange failed:', data);
 }
 } catch (error) {
 throw new Error(error);
 }
};

const getUserDetails = async () => {
 try {
 const token = await getCookie('token');

 if (!token) {
 return null;
 }
 const profileResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
 headers: {
 Authorization: `Bearer ${token}`,
 },
 });

 const user = await profileResponse.json();
 if (!profileResponse.ok) {
 return null;
 }
 return user;
 } catch (error) {
 throw new Error(error);
 }
};

const logout = async () => {
 const expirationDate = new Date();
 expirationDate.setTime(expirationDate.getTime() - 1); // Set expiration in the past
 document.cookie = `token=; expires=${expirationDate.toUTCString()}; path=/`;
 window.location.href = '/';
};

export { signInWithGoogle, handleOAuthCallback, getUserDetails, logout,getCookie };